import { Paper, Box, Typography, Button } from '@mui/material';
import TimelineList from 'components/TimelineList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SummaryTimeline } from 'types/timeline.types';

function SummaryEvents({ events, loading }: { events?: SummaryTimeline[]; loading: boolean }) {
  const { t } = useTranslation('_common');

  const haveData = events && (events?.length || 0) > 0;
  const isEmpty = !loading && !haveData;

  return (
    <Paper
      variant="outlined"
      sx={{
        pt: 2,
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: '1 1 auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          flex: '0 0 auto',
        }}
      >
        <Typography variant="h6">{t('events')}</Typography>
        <Button component={Link} to="/events">
          {t('see_all')}
        </Button>
      </Box>
      {loading && <TimelineList.Loading />}
      {haveData && (
        <TimelineList.Content
          events={events}
          mountAdditionalSecondaryText={(event) => (
            <>
              <Box
                sx={{
                  bgcolor: 'text.disabled',
                  width: 4,
                  height: 4,
                  borderRadius: '4px',
                  mx: 0.5,
                }}
              />
              <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {`${t('account')}: ${(event as SummaryTimeline).accountCode} - ${
                  (event as SummaryTimeline).accountName
                }`}
              </Box>
            </>
          )}
        />
      )}
      {isEmpty && <TimelineList.Empty />}
    </Paper>
  );
}

export default SummaryEvents;
